import * as Sentry from '@sentry/nuxt'
import Clarity from '@microsoft/clarity'

import { pick } from '@shared/lib/object'
import { getClarityUrl } from '@shared/lib/links'

import { useToolsStore } from './store'

export const initClarity = (): void => {
  const runtimeConfig = useRuntimeConfig().public
  const environment = runtimeConfig.environment || null

  const toolsStore = useToolsStore()

  const projectId = 'vg71pxljje'

  const clarityUrl = getClarityUrl(projectId)

  const ready = toolsStore.isClarityReady

  if (!ready) {
    if (projectId) {
      Clarity.init(projectId)

      toolsStore.setClarityReady(true)

      const customerInfo = pick({
        environment,
        app: 'hiring-app',
      })

      const customerClarityInfo = pick({
        ...customerInfo,
      })

      Object.entries(customerClarityInfo).forEach(item => {
        const key = item[0] as string
        const value = item[1] as string
        Clarity.setTag(key, value)
      })

      Sentry.setContext('Customer info', {
        ...customerInfo,
        clarity_url: clarityUrl,
      })
    }
  }
}
